import { STATUS_TYPE } from '../../../enum';
import { Shape } from '../../shape/api/interface';

export interface ReadShapeItems {
  shapeId: string;
  top: string;
  front: string;
  shape: Shape;
}
export interface ShapeItems {
  shapeId: string;
  top: string;
  front: string;
}

export interface ReadItems {
  id?: string;
  code: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  isNew: boolean;
  price: string;
  discountedPrice: string;
  effortScore: string;
  hasColor: boolean;
  previewUrl: string;
  position: string;
  activeState: boolean;
  shapeImages: ReadShapeItems[];
}
export interface Items {
  id?: string;
  code: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  isNew: boolean;
  price: string;
  discountedPrice: string;
  effortScore: string;
  hasColor: boolean;
  previewUrl: string;
  position: string;
  activeState: boolean;
  shapeItems: ShapeItems[];
}
export interface FindToppingsCategory {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetToppingsCategory {
  id: string;
}

export interface CreatePatchToppingsCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string;
  position: string;
  items?: Items[];
  activeState: boolean;
}

export interface ToppingsCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string;
  position: string;
  topping_category_items: ReadItems[];
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: ToppingsCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
